export const TabPanel = (props: any) => {
  const { children, value, selectedValue } = props;
  if (value === selectedValue) {
    return (
      <div role="tabpanel" className="tabpanel">
        {value === selectedValue && children}
      </div>
    );
  }
  return null;
};
